import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { PageLoader } from "../components/Loader";
import { posterAuth } from "../api/poster";
import { setCachedPosterUser, setPosterToken } from "../session";
import { MOCK_USER } from "../mocks";

const IS_DEV = process.env.REACT_APP_DEV === "true";

const RESERVED = new Set([
  "catalog",
  "settings",
  "register",
  "onboarding",
  "spots",
  "dashboard",
  "help",
]);

/**
 * Сегмент пути как OAuth `code` (см. `POST /api/auth`).
 * Зарезервированные пути ведут на каталог.
 */
export default function OAuthCodePage() {
  const { code } = useParams();
  const nav = useNavigate();
  const [err, setErr] = useState(/** @type {string | null} */(null));
  const [done, setDone] = useState(false);

  useEffect(() => {
    if (!code) {
      nav("/catalog", { replace: true });
      return;
    }
    if (RESERVED.has(code)) {
      nav("/catalog", { replace: true });
      return;
    }

    let cancel = false;
    (async () => {
      try {
        if (IS_DEV) {
          const user = MOCK_USER;
          if (user?.access_token) {
            setPosterToken(String(user.access_token));
            setCachedPosterUser(/** @type {object} */(user));
          }
        } else {
          const user = await posterAuth(code);
          if (user?.access_token) {
            setPosterToken(String(user.access_token));
            setCachedPosterUser(/** @type {object} */(user));
          } else {
            setErr("В ответе нет access_token");
            return;
          }
        }
        if (!cancel) {
          setDone(true);
          nav("/catalog", { replace: true });
        }
      } catch (e) {
        if (!cancel) {
          setErr(/** @type {any} */(e).message || "Ошибка авторизации");
        }
        window.top?.postMessage({ hideSpinner: true }, "*");
      }
    })();
    return () => {
      cancel = true;
    };
  }, [code, nav]);

  if (err) {
    return (
      <section className="bodyContainer">
        <h2>Ошибка</h2>
        <p className="text-danger">{err}</p>
      </section>
    );
  }
  if (!done) {
    return (
      <section className="bodyContainer">
        <PageLoader label="Вход" />
      </section>
    );
  }
  return null;
}
